import { QuestionDifficulty, type PAnalysisCell } from '@report/graphql';

export type DifficultyLevel = 'easy' | 'medium' | 'hard';

const DIFFICULTY_RANK: Record<DifficultyLevel, number> = {
  easy: 1,
  medium: 2,
  hard: 3,
};

const DIFFICULTY_LEVEL_MAP = {
  [QuestionDifficulty.Easy]: 'easy',
  [QuestionDifficulty.Medium]: 'medium',
  [QuestionDifficulty.Hard]: 'hard',
} as const;

export function getDifficultyLevelDiff(
  currentDifficultyLevel?: DifficultyLevel,
  targetDifficultyLevel?: DifficultyLevel,
): number {
  const calculateDifficultyRank = (level: DifficultyLevel | undefined): number =>
    level ? DIFFICULTY_RANK[level] : 0;

  return Math.abs(
    calculateDifficultyRank(currentDifficultyLevel) -
      calculateDifficultyRank(targetDifficultyLevel),
  );
}

export function getDifficultyLevelDiffCount(pAnalysisCells: PAnalysisCell[]) {
  return pAnalysisCells.reduce(
    (acc, cell) => {
      const difficultyLevelDiff = getDifficultyLevelDiff(
        DIFFICULTY_LEVEL_MAP[cell.pUsedDifficulty],
        DIFFICULTY_LEVEL_MAP[cell.pCalculatedWithThresholdDifficulty],
      );

      if (difficultyLevelDiff === 1) {
        acc.oneLevelDiffCount += cell.totalQuestions;
      } else if (difficultyLevelDiff === 2) {
        acc.twoLevelDiffCount += cell.totalQuestions;
      }

      return acc;
    },
    {
      oneLevelDiffCount: 0,
      twoLevelDiffCount: 0,
    },
  );
}
